import { Route, elementsToRoutes } from './utils/components/router';

import KundenaddressEditMA from "./Mitarbeiter/KundenaddressEditMA";
import KundenOrderDetailsMA from "./Mitarbeiter/KundenOrderDetailsMA";
import KundenEditMA from "./Mitarbeiter/KundenEditMA";
import KundenRecordDataMA from "./Mitarbeiter/KundenRecordDataMA";
import KundenAddresseMA from "./Mitarbeiter/KundenAddresseMA";
import KundenDankeSeiteMA from "./Mitarbeiter/KundenDankeSeiteMA";

import Administration from "./pages/Administration";
import PageNotFound from "./pages/PageNotFound";
import MALogin from "./Mitarbeiter/MALogin";
import ErrorPage from "./pages/Error";
import CONFIG from "./config";
import { contextPath, contextMatchPath } from "./utils/functions";

/* special imports for noblemetals */

import EmpfehlungMA from "./pages/EmpfehlungMA";
import Home from "./home";
import MALoginStart from "./Mitarbeiter/MALoginStart";
import Landingpage from './pages/landingpage';

export const maRoutes = elementsToRoutes(
  <>
    <Route
      path="/home"
      element={<Home appId={CONFIG.applicationId}></Home>}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_EMPFEHLUNG)}
      element={<EmpfehlungMA />}
      meta={{ active: CONFIG.isEdelmetallShop() }}
    />
    <Route
      path="/"
      element={<Landingpage />}
    />
    <Route
      path={contextPath(CONFIG.LINK_MITARBEITERLOGIN)}
      exact
      element={<MALogin redirect={true} />}
    />
    <Route
      path={contextPath(CONFIG.LINK_MITARBEITERLOGIN_KONDITION)}
      exact
      element={<MALogin redirect={true} changeCondition={true} />}
    />
    <Route
      path={contextPath("/mitarbeiterStart/")}
      exact
      element={<MALoginStart />}
      meta={{ active: CONFIG.isEdelmetallShop() }}
    />
    <Route
      exact
      path={contextPath(CONFIG.LINK_MITARBEITER_ADD_KUNDEN)}
      element={<KundenRecordDataMA />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_KUNDENDATEN_EDIT)}
      element={<KundenEditMA />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_KUNDEN_ADDRESSE_MA_EDIT)}
      exact
      element={<KundenaddressEditMA />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_KUNDEN_ADDRESSE_MA)}
      exact
      element={<KundenAddresseMA />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_KUNDEN_ORDER_DETAILS_MA)}
      element={<KundenOrderDetailsMA />}
    />
    <Route
      path={contextMatchPath(CONFIG.LINK_DANKE)}
      exact
      element={<KundenDankeSeiteMA />}
    />
    <Route
      path={contextPath(CONFIG.ANKAUF)}
      exact
      element={<Home appId={CONFIG.applicationIdAnkauf}></Home>}
    />
    <Route
      path={contextPath(CONFIG.LINK_ADMIN_PAGE)}
      exact
      element={<Administration />}
    />
    <Route
      path={contextPath("/error")}
      exact
      element={<ErrorPage />}
    />
    <Route
      element={<PageNotFound />}
    />
  </>
);
